import React from "react";

export const Footer = () => {
  return (
    <footer className="py-4 px-6 flex justify-between text-sm text-primaryDark mt-auto">
      <div className="flex gap-4">
        <a
          href="https://store.nanowattz.com/"
          target="_blank"
          rel="noreferrer"
          className="hover:text-subText text-primaryDark"
        >
          Store
        </a>
        <a
          href="https://nanowattz.com/contact-us"
          target="_blank"
          rel="noreferrer"
          className="hover:text-subText text-primaryDark"
        >
          Support
        </a>
        {/* <a href="#" className="hover:text-subText text-primaryDark">Privacy Policy</a>
        <a href="#" className="hover:text-subText text-primaryDark">Terms of Service</a> */}
      </div>
      <div>© {new Date().getFullYear()} NanoWattz</div>
    </footer>
  );
};

// export Footer;
